var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8437 11.4653L18.2278 12.8494M9 23H10.3978C11.5293 23 12.0951 23 12.6038 22.7893C13.1126 22.5785 13.5127 22.1785 14.3128 21.3783L21.9189 13.7722C22.4221 13.2691 22.6736 13.0175 22.8081 12.7461C23.064 12.2298 23.064 11.6235 22.8081 11.1072C22.6736 10.8358 22.4221 10.5843 21.9189 10.0811C21.4158 9.57796 21.1642 9.32639 20.8928 9.1919C20.3765 8.93603 19.7702 8.93603 19.2539 9.1919C18.9825 9.32639 18.731 9.57796 18.2278 10.0811L10.6217 17.6872C9.82152 18.4873 9.42146 18.8875 9.21073 19.3962C9 19.9049 9 20.4707 9 21.6022V23Z",
    stroke: "#3B84E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5f11e0203147d3ab336303d572a47b54.svg";
export { ForwardRef as ReactComponent };